export default "__VITE_ASSET__BmNIsvTz__"